import { api } from '@tech_hexeko/hexeko-api-classes'

// initial state
const state = () => ({
    baseURL: 'https://api.hexeko.com/api/v1',
    token: null,
    language: 'en'
})

// getters
const getters = {
    api: () => {
        return api
    }
}

// actions
const actions = {
    setBaseURL ({ commit }, url) {
        commit('setBaseURL', { url })
        api.setBaseURL(url)
    },
    setLanguage ({ commit }, lang) {
        commit('setLanguage', { lang })
        api.defaults.headers.common['Accept-Language'] = lang
    },
    setToken ({ commit }, token) {
        commit('setToken', { token })
        api.setToken(token, 'Bearer')
    }
}

// mutations
const mutations = {
    setBaseURL (state, { url }) {
        state.baseURL = url
    },
    setLanguage (state, { lang }) {
        state.language = lang
    },
    setToken (state, { token }) {
        state.token = token
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}